import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ShieldCheckIcon } from 'lucide-react';
const buyers = [{
  name: 'Marco Rossi',
  city: 'Milano'
}, {
  name: 'Giulia Bianchi',
  city: 'Roma'
}, {
  name: 'Francesco Esposito',
  city: 'Napoli'
}, {
  name: 'Elena Romano',
  city: 'Torino'
}, {
  name: 'Alessandro Conti',
  city: 'Bologna'
}, {
  name: 'Chiara Ferrari',
  city: 'Firenze'
}, {
  name: 'Luca Marino',
  city: 'Genova'
}, {
  name: 'Federica Greco',
  city: 'Padova'
}, {
  name: 'Davide Bruno',
  city: 'Bari'
}, {
  name: 'Sara De Luca',
  city: 'Palermo'
}, {
  name: 'Paolo Russo',
  city: 'Verona'
}, {
  name: 'Martina Galli',
  city: 'Catania'
}, {
  name: 'Stefano Riva',
  city: 'Brescia'
}, {
  name: 'Valentina Costa',
  city: 'Venezia'
}, {
  name: 'Andrea Caruso',
  city: 'Bergamo'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-283">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: 50,
      y: -10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: 50,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 24
    }} className="fixed top-4 right-4 sm:top-6 sm:right-6 z-50 max-w-[280px] w-[calc(100%-2rem)]" data-id="element-284">
          <div className="bg-brand-card border border-brand-orange/50 rounded-xl p-3 shadow-[0_0_25px_rgba(249,115,22,0.25)] relative overflow-hidden" data-id="element-285">
            <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-brand-orange via-brand-gold to-brand-orange" data-id="element-286" />

            <button onClick={() => setIsVisible(false)} className="absolute top-1.5 right-1.5 text-gray-500 hover:text-white p-0.5" aria-label="Chiudi" data-id="element-287">
              <XIcon className="w-3.5 h-3.5" data-id="element-288" />
            </button>

            <div className="flex items-center gap-2.5 pr-4" data-id="element-289">
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-brand-orange to-brand-amber flex items-center justify-center text-white font-bold text-sm shrink-0" data-id="element-290">
                {currentBuyer.name.charAt(0)}
              </div>
              <div className="min-w-0 flex-1" data-id="element-291">
                <p className="text-[12px] text-gray-200 font-medium leading-tight" data-id="element-292">
                  <span className="font-bold text-brand-cream" data-id="element-293">
                    {currentBuyer.name}
                  </span>{' '}
                  da{' '}
                  <span className="text-brand-cream" data-id="element-294">{currentBuyer.city}</span>{' '}
                  ha appena acquistato il Sistema Domotica Pro
                </p>
                <div className="flex items-center gap-2 mt-1" data-id="element-295">
                  <span className="flex items-center gap-1 text-[10px] text-green-400 font-bold" data-id="element-296">
                    <ShieldCheckIcon className="w-2.5 h-2.5" data-id="element-297" />
                    Verificato
                  </span>
                  <span className="text-[10px] text-gray-500" data-id="element-298">
                    {timeAgo} min fa
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}